import { render, staticRenderFns } from "./ApplicantResume.vue?vue&type=template&id=c133e53c"
import script from "./ApplicantResume.vue?vue&type=script&lang=js"
export * from "./ApplicantResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports